<template>
  <div class="container">
    <h1 class="py-4">ユーザ詳細</h1>
    <div v-if="show" :key="key">
      <div v-if="loading">loading...</div>
      <div v-if="!loading" class="table-responsive">
        <h3 class="py-4">顧客情報</h3>
        <div class="d-flex flex-wrap">
          <div
            v-for="(data, name, i) in this.userInfo"
            :key="i"
            class="d-flex datacontainer flex-nowrap"
          >
            <div
              v-if="i == 0 || i == 1"
              class="grey-background greyBorder property d-flex"
            >
              <p>{{ name }}</p>
            </div>
            <div v-if="i == 0 || i == 1" class="greyBorder value d-flex">
              <p>{{ data }}</p>
            </div>
            <div
              v-if="i !== 0 && i !== 1"
              class="grey-background greyBorderNoTop property d-flex"
            >
              <p>{{ name }}</p>
            </div>
            <div
              v-if="(i !== 0) & (i !== 1)"
              class="greyBorderNoTop value d-flex"
            >
              <p>{{ data }}</p>
            </div>
          </div>
        </div>
        <h3 class="py-4">契約情報</h3>
        <div class="d-flex flex-wrap">
          <div
            v-for="(data, name, id) in this.contractInfo"
            :key="id"
            class="d-flex datacontainer flex-nowrap"
          >
            <div
              v-if="id == 0 || id == 1"
              class="grey-background greyBorder property d-flex"
            >
              <p>{{ name }}</p>
            </div>
            <div v-if="id == 0 || id == 1" class="greyBorder value d-flex">
              <p>{{ data }}</p>
            </div>
            <div
              v-if="id !== 0 && id !== 1"
              class="grey-background greyBorderNoTop property d-flex"
            >
              <p>{{ name }}</p>
            </div>
            <div
              v-if="(id !== 0) & (id !== 1)"
              class="greyBorderNoTop value d-flex"
            >
              <p>{{ data }}</p>
            </div>
          </div>
          <div class="d-flex datacontainerFullWidth flex-nowrap">
            <div class="grey-background greyBorderNoTop property d-flex wd175">
              <p>申込番号</p>
            </div>
            <div class="greyBorderNoTop value wd825 d-flex">
              <p>{{ entry_number }}</p>
            </div>
          </div>
          <div
            v-for="(data, name) in this.contractInfoExtras"
            :key="name"
            class="d-flex datacontainer flex-nowrap"
          >
            <div class="grey-background greyBorderNoTop property d-flex">
              <p>{{ name }}</p>
            </div>
            <div class="greyBorderNoTop value d-flex">
              <p>{{ data }}</p>
            </div>
          </div>
        </div>
        <br />
        <div class="d-flex flex-wrap">
          <div class="d-flex datacontainerFullWidth flex-nowrap">
            <div class="grey-background greyBorder container25 d-flex">
              <p class="ml05">利用限度額</p>
            </div>
            <div class="grey-background greyBorder container25 d-flex">
              <p>1回</p>
            </div>
            <div class="grey-background greyBorder container25 d-flex">
              <p>1日</p>
            </div>
            <div class="grey-background greyBorder container25 d-flex">
              <p>1ヶ月</p>
            </div>
          </div>
          <div class="d-flex datacontainerFullWidth flex-nowrap">
            <div class="grey-background greyBorderNoTop container25 d-flex">
              <p class="ml05">国内ショッピング</p>
            </div>
            <div class="greyBorderNoTop container25 d-flex flex-end">
              <p class="mr05 ml00">{{ shoppingInfo.usage_limit_1_time }}</p>
            </div>
            <div class="greyBorderNoTop container25 d-flex flex-end">
              <p class="mr05 ml00">{{ shoppingInfo.usage_limit_day }}</p>
            </div>
            <div class="greyBorderNoTop container25 d-flex flex-end">
              <p class="mr05 ml00">{{ shoppingInfo.usage_limit_month }}</p>
            </div>
          </div>
          <div class="d-flex datacontainerFullWidth flex-nowrap">
            <div class="grey-background greyBorderNoTop container25 d-flex">
              <p class="ml05">国際ショッピング</p>
            </div>
            <div class="greyBorderNoTop container25 d-flex">
              <p class="mr05 ml00">
                {{ shoppingInfo.usage_limit_1_time_overseas }}
              </p>
            </div>
            <div class="greyBorderNoTop container25 d-flex">
              <p class="mr05 ml00">
                {{ shoppingInfo.usage_limit_day_overseas }}
              </p>
            </div>
            <div class="greyBorderNoTop container25 d-flex">
              <p class="mr05 ml00">
                {{ shoppingInfo.usage_limit_month_overseas }}
              </p>
            </div>
          </div>
          <div class="d-flex datacontainerFullWidth flex-nowrap">
            <div class="grey-background greyBorderNoTop container25 d-flex">
              <p class="ml05">海外現金引出</p>
            </div>
            <div class="greyBorderNoTop container25 d-flex">
              <p class="mr05 ml00">
                {{ shoppingInfo.withdraw_limit_1_overseas }}
              </p>
            </div>
            <div class="greyBorderNoTop container25 d-flex">
              <p class="mr05 ml00">
                {{ shoppingInfo.withdraw_limit_day_overseas }}
              </p>
            </div>
            <div class="greyBorderNoTop container25 d-flex">
              <p class="mr05 ml00">
                {{ shoppingInfo.withdraw_limit_month_overseas }}
              </p>
            </div>
          </div>
        </div>
        <br />
        <div class="d-flex datacontainerFullWidth flex-nowrap">
          <div class="grey-background greyBorder container25 d-flex">
            <p class="ml05">プリペイド口座残高</p>
          </div>
          <div class="greyBorder container75 d-flex">
            <p class="mr05 ml00">{{ shoppingInfo.account_balance }}</p>
          </div>
        </div>
        <br />
        <div class="d-flex flex-wrap">
          <div
            v-for="(data, name, inde) in this.contractBisInfo"
            :key="inde"
            class="d-flex datacontainer flex-nowrap"
          >
            <div class="grey-background greyBorder property d-flex">
              <p>{{ name }}</p>
            </div>
            <div class="greyBorder value d-flex">
              <p>{{ data }}</p>
            </div>
          </div>
        </div>
        <br />
        <div class="d-flex flex-wrap">
          <div
            v-for="(data, name, inde) in this.contractDates"
            :key="inde"
            class="d-flex datacontainer33 flex-nowrap"
          >
            <div class="grey-background greyBorder property50 d-flex">
              <p>{{ name }}</p>
            </div>
            <div class="greyBorder value50 d-flex">
              <p>{{ data }}</p>
            </div>
          </div>
        </div>
        <br />
        <h3 class="py-4">カード情報</h3>
        <div class="d-flex flex-wrap">
          <div
            v-for="(data, name, index) in this.cardInfo"
            :key="index"
            class="d-flex datacontainer flex-nowrap"
          >
            <div
              v-if="index == 0 || index == 1"
              class="grey-background greyBorder property d-flex"
            >
              <p>{{ name }}</p>
            </div>
            <div
              v-if="index == 0 || index == 1"
              class="greyBorder value d-flex"
            >
              <p>{{ data }}</p>
            </div>
            <div
              v-if="index !== 0 && index !== 1"
              class="grey-background greyBorderNoTop property d-flex"
            >
              <p>{{ name }}</p>
            </div>
            <div
              v-if="index !== 0 && index !== 1"
              class="greyBorderNoTop value d-flex"
            >
              <p>{{ data }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right mb50">
        <button class="btn btn-outline-dark mr20" @click="navigateSettlements">
          決済•手数料データ詳細 >
        </button>
      </div>
      <div class="d-flex flex-wrap" v-if="showApplicationUserData">
        <div class="d-flex datacontainerFullWidth flex-nowrap">
          <div class="grey-background greyBorder container175 d-flex">
            <p class="ml05">popInfoID</p>
          </div>
          <div class="greyBorder container825 d-flex">
            <p class="mr05 ml00">{{ applicationUserData.popInfoId }}</p>
          </div>
        </div>
        <div class="d-flex datacontainerFullWidth flex-nowrap">
          <div class="grey-background greyBorder container175 d-flex">
            <p class="ml05">メールアドレス</p>
          </div>
          <div class="greyBorder container825 d-flex">
            <p class="mr05 ml00">{{ applicationUserData.mailAddress }}</p>
          </div>
        </div>
      </div>

      <div v-if="show2">
        <h4 class="py-4">c.choy-san会員情報</h4>
        <div v-if="loading2">loading...</div>
        <div v-if="!loading2" class="d-flex flex-wrap">
          <div class="d-flex datacontainerFullWidth flex-nowrap">
            <div class="grey-background greyBorder container175 d-flex">
              <p class="ml05">UID</p>
            </div>
            <div class="greyBorder container825 d-flex">
              <p class="mr05 ml00">{{ choysanData.UID }}</p>
            </div>
          </div>
          <div
            v-for="(data, name, index) in this.choysanBisData"
            :key="index"
            class="d-flex datacontainer flex-nowrap"
          >
            <div class="grey-background greyBorderNoTop property d-flex">
              <p>{{ name }}</p>
            </div>
            <div class="greyBorderNoTop value d-flex">
              <p>{{ data }}</p>
            </div>
          </div>
          <div class="d-flex datacontainerFullWidth flex-nowrap">
            <div class="grey-background greyBorderNoTop container175 d-flex">
              <p class="ml05">リンク元URL</p>
            </div>
            <div class="greyBorderNoTop container825 d-flex">
              <p class="mr05 ml00">{{ choysanData.source }}</p>
            </div>
          </div>
          <div class="d-flex datacontainerFullWidth flex-nowrap">
            <div class="grey-background greyBorderNoTop container175 d-flex">
              <p class="ml05">パートナID</p>
            </div>
            <div class="greyBorderNoTop container825 d-flex">
              <p class="mr05 ml00">{{ choysanData.pid }}</p>
            </div>
          </div>
          <div class="d-flex datacontainer flex-nowrap">
            <div class="grey-background greyBorderNoTop property d-flex">
              <p>在留資格</p>
            </div>
            <div class="greyBorderNoTop value d-flex">
              <p>{{ choysanData.zairyuuShikaku }}</p>
            </div>
          </div>
          <div class="d-flex datacontainer flex-nowrap">
            <div class="grey-background greyBorderNoTop property d-flex">
              <p>在留資格（その他）</p>
            </div>
            <div class="greyBorderNoTop value d-flex">
              <p>{{ choysanData.zairyuOther }}</p>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import sex from "@/constants/SexEnum";
import countries from "@/constants/CountriesEnum";
import prefs from "@/constants/PrefsEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";

export default {
  name: "ContractDetails",
  mixins: [utils, master, sex, countries, prefs],
  data() {
    return {
      contractId: "",
      userData: [],
      userInfo: [],
      contractInfo: [],
      contractInfoExtras: [],
      contractBisInfo: [],
      contractDates: [],
      cardInfo: [],
      shoppingInfo: [],
      applicationUserData: [],
      popInfoID: "",
      entry_number: "",
      unformatedChoysanData: [],
      choysanData: [],
      choysanBisData: [],
      userPointData: [],
      settlementsData: [],
      show: false,
      show2: false,
      loading: true,
      showApplicationUserData: false,
      db: firebase.firestore(),
    };
  },
  created: function() {
    this.contractId = this.$route.query.contractId.toString();
    this.loadData();
  },
  methods: {
    init() {
      this.show = false;
      this.show2 = false;
      this.key = this.key ? 0 : 1;
    },
    async navigateSettlements() {
      this.$router.push({
        name: "SettlementDetails",
        query: { contractId: this.contractId },
      });
    },
    async loadData() {
      this.init();
      const doc = await this.db
        .collection("master")
        .doc(this.contractId)
        .get();
      if (doc.exists) {
        var mobile = doc.data().mobile;
        for (const [key, value] of Object.entries(doc.data())) {
          if (key == "mobile_0") {
            // do nothing, skip mobile_0
          } else if (this.fields[key] == undefined) this.userData[key] = value;
          else if (key == "created_at")
            this.userData[this.fields[key]] = this.formatDateTime(
              value.toDate()
            );
          else this.userData[this.fields[key]] = value;
        }
        this.userInfo = this.copyFields(this.userData, [
          "telephone",
          "mobile",
          "postal_code",
          "address1",
          "address2",
          "customer_update_day",
        ]);
        this.contractInfo = this.copyFields(this.userData, [
          "contract_number",
          "customer_number",
          "branch_number",
          "account_type",
          "account_number",
          "account_number_branch",
          "authentication_a",
          "a_date_confirmation",
          "authentication_b",
          "b_date_confirmation",
          "brand_id",
          "grade_id",
          "card_type",
          "valid_member_flag",
          "transaction_purpose",
          "occupation",
        ]);
        let valid_member_text = this.valid_member_options[
          this.contractInfo.有効会員フラグ
        ];
        if (valid_member_text !== undefined) {
          this.contractInfo.有効会員フラグ = valid_member_text;
        }

        this.contractInfoExtras = this.copyFields(this.userData, [
          "identification",
          "representative_contract_number",
        ]);
        this.shoppingInfo = this.copyFields(
          this.userData,
          [
            "usage_limit_1_time",
            "usage_limit_day",
            "usage_limit_month",
            "usage_limit_1_time_overseas",
            "usage_limit_day_overseas",
            "usage_limit_month_overseas",
            "withdraw_limit_1_overseas",
            "withdraw_limit_day_overseas",
            "withdraw_limit_month_overseas",
            "account_balance",
          ],
          true
        );
        this.contractBisInfo = this.copyFields(this.userData, [
          "contract_date",
          "cancellation_date",
        ]);
        this.contractDates = this.copyFields(this.userData, [
          "contract_update_day",
          "data_entry_date",
          "data_created_at",
        ]);
        this.cardInfo = this.copyFields(this.userData, [
          "kana_name",
          "kanji_name",
          "emboss",
          "gender",
          "birthday",
          "card_expiration",
          "last_good_through",
          "application_date",
          "card_issuance_instruction_date",
          "card_shipping_date",
          "rankup_date",
          "card_issuance_date",
        ]);
        this.popInfoID = doc.data().popinfoId;
        this.entry_number = doc.data().entry_number;
        if (this.contractInfoExtras["名寄せ識別"] !== "") {
          this.contractInfoExtras["名寄せ識別"] = this.identification_codes[
            this.contractInfoExtras["名寄せ識別"]
          ];
        }
        if (this.contractInfo["預金種別"] !== "") {
          this.contractInfo["預金種別"] = this.account_type_codes[
            this.contractInfo["預金種別"]
          ];
        }
        if (this.contractInfo["本人確認資料A種別"] !== "") {
          this.contractInfo["本人確認資料A種別"] = this.authentication_a_codes[
            this.contractInfo["本人確認資料A種別"]
          ];
        }
        if (this.contractInfo["本人確認資料B種別"] !== "") {
          this.contractInfo["本人確認資料B種別"] = this.authentication_b_codes[
            this.contractInfo["本人確認資料B種別"]
          ];
        }
        if (this.contractInfo["カード種類"] !== "") {
          this.contractInfo["カード種類"] = this.card_type_codes[
            this.contractInfo["カード種類"]
          ];
        }
        if (this.contractInfo["取引目的"] !== "") {
          if (this.contractInfo["取引目的"] == 7) {
            this.contractInfo["取引目的"] = this.transaction_purpose_codes[
              this.contractInfo["取引目的"]
            ];
            this.contractInfo["取引目的"] +=
              "(" + this.userData["取引目的（その他）"] + ")";
          } else {
            this.contractInfo["取引目的"] = this.transaction_purpose_codes[
              this.contractInfo["取引目的"]
            ];
          }
        }
        if (this.contractInfo["職業"] !== "") {
          if (this.contractInfo["職業"] == 10) {
            this.contractInfo["職業"] = this.occupation_codes[
              this.contractInfo["職業"]
            ];
            this.contractInfo["職業"] +=
              "(" + this.userData["職業（その他）"] + ")";
          } else {
            this.contractInfo["職業"] = this.occupation_codes[
              this.contractInfo["職業"]
            ];
          }
        }
        if (this.cardInfo["性別区分"] !== "") {
          this.cardInfo["性別区分"] = this.sex[this.cardInfo["性別区分"]];
        }
        const snapshot = await this.db
          .collection("paymentMethod")
          .where("contract_number", "==", this.contractId)
          .limit(1)
          .get();
        if (snapshot.docs[0] !== undefined) {
          const repaymentData = snapshot.docs[0].data();
          const snapshotUserData = await this.db
            .collection("applicationUsers")
            .where(
              "application_user_id",
              "==",
              repaymentData.application_user_id
            )
            .limit(1)
            .get();
          if (snapshotUserData.docs[0] !== undefined) {
            const appUserData = snapshotUserData.docs[0].data();
            this.applicationUserData.popInfoId = appUserData.popinfoID;
            this.applicationUserData.mailAddress = appUserData.mail_address;
            this.showApplicationUserData = true;
          } else {
            this.showApplicationUserData = false;
          }
        }
        if (mobile !== undefined && mobile !== "") {
          await this.db
            .collection("users")
            .where("phone", "==", mobile.toString())
            .where("status", "==", "1")
            .limit(1)
            .get()
            .then((query) => {
              if (!query.empty) {
                let choysanDoc = query.docs[0];
                for (const [key, value] of Object.entries(choysanDoc.data())) {
                  if (this.fields[key] == undefined)
                    this.unformatedChoysanData[key] = value;
                  else if (
                    key == "created_at" ||
                    key == "updated_at" ||
                    key == "telephone_0" ||
                    key == "mobile_0"
                  ) {
                    // do nothing, don't add
                  } else if (key == "sex") {
                    this.unformatedChoysanData[this.fields[key]] = this.sex[
                      value
                    ];
                  } else if (key == "country_code") {
                    this.unformatedChoysanData[
                      this.fields[key]
                    ] = this.countries.find(
                      (element) => element.code == value
                    ).name;
                  } else if (key == "pref_code") {
                    this.unformatedChoysanData[
                      this.fields[key]
                    ] = this.prefs.find(
                      (element) => element.code == value
                    ).name;
                  } else if (key == "birthday") {
                    this.unformatedChoysanData[
                      this.fields[key]
                    ] = this.formatDateTime(value.toDate());
                  } else this.unformatedChoysanData[this.fields[key]] = value;
                }
                this.unformatedChoysanData["UID"] = choysanDoc.id;
                this.choysanData = this.copyFields(
                  this.unformatedChoysanData,
                  ["UID", "source", "pid", "zairyuuShikaku", "zairyuOther"],
                  true
                );
                this.choysanBisData = this.copyFields(
                  this.unformatedChoysanData,
                  [
                    "first_name_en",
                    "last_name_en",
                    "middle_name_en",
                    "phone",
                    "birthday",
                    "sex",
                    "country_code",
                    "pref_code",
                    "nickname",
                    "redirect",
                  ]
                );
                this.loading2 = false;
                this.show2 = true;
              }
            });
        }
        this.loading = false;
        this.show = true;
      } else {
        this.$router.push({ name: "Home" });
      }
    },
    copyFields: function(from, fields, englishFieldName = false) {
      let to = [];
      if (!englishFieldName) {
        fields.forEach((key) => {
          to[this.fields[key]] = from[this.fields[key]];
        });
      } else {
        fields.forEach((key) => {
          to[key] = from[this.fields[key]];
        });
      }

      let json = Object.assign({}, to);
      return json;
    },
  },
};
</script>
